import React from "react";
import "./CategoryTitle.css";
import { Link } from "react-router-dom";
import { useLanguage } from "./LanguageContext";

const categoryLabels = {
    Eventy: "events",
    Muzea: "museums",
    Teatry: "theatres",
    Kina: "cinemas",
    Zabytki: "monuments",
    KulturaInne: "other",
    Restauracje: "restaurants",
    "Fast Foody": "fastFood",
    Kawiarnie: "cafes",
    Desery: "desserts",
    GastronomiaInne: "other",
    Biblioteki: "libraries",
    Księgarnie: "bookstores",
    Kursy: "courses",
    "Targi i kiermasze": "fairs",
    NaukaInne: "other",
    Artykuły: "articles",
    "O nas": "about",
};

const categoryDescriptions = {
    pl: {
        Eventy: "Wydarzenia, które warto dodać do swojego kalendarza.",
        Muzea: "Miejsca, w których historia, sztuka i wiedza spotykają się na żywo.",
        Teatry: "Sceny pełne historii, emocji i spotkań z kulturą.",
        Kina: "Seanse, premiery i filmowe doświadczenia na dużym ekranie.",
        Zabytki: "Ślady historii, które warto zobaczyć z bliska.",
        KulturaInne: "Inne miejsca i inicjatywy tworzące życie kulturalne miasta.",
        Restauracje: "Miejsca na codzienny posiłek i wyjątkowe kulinarne wyjścia.",
        "Fast Foody": "Szybkie i sprawdzone miejsca, kiedy liczy się czas.",
        Kawiarnie: "Kawa, deser i chwila oddechu w dobrym miejscu.",
        Desery: "Słodkie miejsca na małą przyjemność.",
        GastronomiaInne: "Pozostałe miejsca, które warto odkryć przy stole.",
        Biblioteki: "Przestrzenie dla książek, nauki i spokojnej pracy.",
        Księgarnie: "Miejsca dla tych, którzy zawsze szukają kolejnej dobrej książki.",
        Kursy: "Zajęcia i warsztaty, które pomagają rozwijać nowe umiejętności.",
        "Targi i kiermasze": "Spotkania z lokalnymi twórcami, produktami i pomysłami.",
        NaukaInne: "Miejsca i inicjatywy dla ciekawych świata.",
    },
    en: {
        Eventy: "Events worth adding to your calendar.",
        Muzea: "Places where history, art and knowledge come together.",
        Teatry: "Stages full of stories, emotions and culture.",
        Kina: "Screenings, premieres and cinematic experiences on the big screen.",
        Zabytki: "Traces of history worth seeing up close.",
        KulturaInne: "Other places and initiatives that shape the city's cultural life.",
        Restauracje: "Places for an everyday meal and a special culinary outing.",
        "Fast Foody": "Quick, reliable places for when time matters.",
        Kawiarnie: "Coffee, dessert and a moment to pause in a good place.",
        Desery: "Sweet places for a little treat.",
        GastronomiaInne: "Other places worth discovering around the table.",
        Biblioteki: "Spaces for books, learning and focused work.",
        Księgarnie: "Places for everyone looking for their next good book.",
        Kursy: "Classes and workshops that help develop new skills.",
        "Targi i kiermasze": "Meet local creators, products and ideas.",
        NaukaInne: "Places and initiatives for people curious about the world.",
    },
};

function CategoryTitle(props){
    const { language, t } = useLanguage();

    function getCategoryString(category){
        let slicedWord = category.slice(category.length > 4 ? category.length - 4 : 0, category.length);
        if (slicedWord === "Inne" || slicedWord === "inne"){
            if (category.length > 5){
                return category.slice(0, category.length - 4) + " " + slicedWord;
            }
        }

        return category;
    }

    function getCategoryImage(category){
        let result = "/images/category/";
        switch (category) {
            case "Eventy":
                result = result + "kategoria-eventy.jpg";
                break;
            case "Muzea":
                result = result + "kategoria-muzea.jpg";
                break;
            case "Teatry":
                result = result + "kategoria-teatry.jpg";
                break;
            case "Kina":
                result = result + "kategoria-kina.jpg";
                break;
            case "Zabytki":
                result = result + "kategoria-zabytki.jpeg";
                break;
            case "KulturaInne":
                result = result + "kategoria-kultura-inne.jpg";
                break;
            case "Restauracje":
                result = result + "kategoria-restauracje.jpg";
                break;
            case "Fast Foody":
                result = result + "kategoria-fastFoody.jpg";
                break;
            case "Kawiarnie":
                result = result + "kategoria-kawiarnie.jpg";
                break;
            case "Desery":
                result = result + "kategoria-desery.jpg";
                break;
            case "GastronomiaInne":
                result = result + "kategoria-restauracje.jpg";
                break;
            case "Biblioteki":
                result = result + "kategoria-biblioteki.jpg";
                break;
            case "Księgarnie":
                result = result + "kategoria-ksiegarnie.jpg";
                break;
            case "Kursy":
                result = result + "kategoria-kursy.jpg";
                break;
            case "Targi i kiermasze":
                result = result + "kategoria-targi.jpg";
                break;
            case "NaukaInne":
                result = result + "kategoria-nauka-inne.jpg";
                break;
            case "Artykuły":
                result = result + "category-article.jpg";
                break;
            case "O nas":
                result = "/images/o-nas.jpg";
                break;
            default:
                result = result + "kategoria-kultura-inne.jpg";
                break;
        }

        return result;
    }

    function getCategoryDescription(category){
        const result = categoryDescriptions[language]?.[category];

        if (!result) {
            return null;
        }

        return (
            <div className="category-description-text">
                <p>{result}</p>
                <Link className="category-description-link" to={"/informacje/" + props.category}>
                    {t("categoryReadMore")}
                </Link>
            </div>
        )
    }

    return (
        <header className="category-title">
            <img src={getCategoryImage(props.category)} alt="" />

            <div className="category-description">
                <h1>{t(categoryLabels[props.category])}</h1>
                { props.categoryInfo !== undefined ? "" : getCategoryDescription(props.category) }
            </div>
        </header>
    )
};

export default CategoryTitle;